import { render, staticRenderFns } from "./redirectTable.vue?vue&type=template&id=aad3fc96&scoped=true&"
import script from "./redirectTable.vue?vue&type=script&lang=js&"
export * from "./redirectTable.vue?vue&type=script&lang=js&"
import style0 from "./redirectTable.vue?vue&type=style&index=0&id=aad3fc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad3fc96",
  null
  
)

export default component.exports